export default "__VITE_ASSET__gQutNtCx__"